import { useState } from 'react';

import { useImpactAdvocateEnabled } from 'modules/common/hooks/useImpactAdvocateEnabled';
import useUser from 'modules/HubV2/common/queries/user';
import useAuthSelectors from 'modules/Auth/AuthProvider/useAuthSelector';
import { getCookie } from 'modules/common/utils';
import useReferralPromoConfig from 'modules/common/hooks/useReferralPromoConfig';
import GiftIcon from 'modules/common/components/Icons/GiftIcon';
import ReferralModal from 'modules/common/components/ReferralModal';
import ChipButton from 'modules/common/components/Layout/Header/ChipButton';
import useImpactJwt from 'services/impact/queries/useImpactJwt';

const PLACEHOLDER_EMAIL = 'user@example.com';

export default function ReferralButton() {
    const { calculateRewardBalance } = useReferralPromoConfig();
    const isFunnelOrReferralsPage = window.location.pathname.includes('referrals');
    const isImpactAdvocateEnabled = useImpactAdvocateEnabled();
    const { data: user } = useUser();
    const { isImpersonating } = useAuthSelectors('isImpersonating');

    const [isModalRequested, setIsModalRequested] = useState(false);

    const canRequestJwt = !isImpersonating && !!user?.email && user.email !== PLACEHOLDER_EMAIL;
    const {
        data: jwtToken,
        error: jwtError,
        isFetching: isJwtFetching,
    } = useImpactJwt(
        user?.email
            ? {
                  email: user.email,
                  firstName: user.first_name,
                  lastName: user.last_name,
                  cookies: getCookie('_saasquatch') || undefined,
              }
            : undefined,
        { enabled: isModalRequested && canRequestJwt }
    );

    if (isFunnelOrReferralsPage || !isImpactAdvocateEnabled) {
        return null;
    }

    const handleClick = () => {
        if (!canRequestJwt) {
            return;
        }
        setIsModalRequested(true);
    };

    const handleClose = () => setIsModalRequested(false);

    return (
        <>
            <ChipButton
                onClick={handleClick}
                icon={<GiftIcon />}
                label={`Earn ${calculateRewardBalance(1)}`}
                sx={{
                    bgcolor: 'green.100',
                    color: 'green.600',
                    '&:hover': {
                        bgcolor: 'green.200',
                    },
                    '& .MuiChip-label': {
                        typography: 'subtitle2',
                    },
                    '& .MuiChip-icon': {
                        marginLeft: 0,
                        typography: 'button',
                        color: 'green.600',
                    },
                }}
                variant="filled"
            />
            <ReferralModal
                open={isModalRequested && !isJwtFetching}
                onClose={handleClose}
                jwtToken={jwtToken ?? null}
                jwtError={jwtError?.message ?? null}
            />
        </>
    );
}
